import Media from 'components/shared/Media/Media';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextList from 'components/shared/RichTextList/RichTextList';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { CardsStackedItemBaseProps } from './types';
import { cn, getColorway } from 'utils/styles';

const CardsStackedItemIconVariant = ({
  sys,
  sectionName,
  desktopMedia,
  headline,
  shortDescription,
  color,
  desktopAnimation,
}: CardsStackedItemBaseProps) => {
  const cardWrapperClasses = cn(
    `rounded-lg active:rounded-lg px-4 py-8 w-full relative`,
    `flex flex-row items-center gap-6 md:basis-1/3-gap-6 md:grow-1`,
    `group-data-[num-items=4]:md:basis-1/2-gap-6`,
    getColorway(color),
  );

  // Resize media to the rendered size
  const resizedDesktopMedia = desktopMedia ? { ...desktopMedia, width: 72, height: 72 } : undefined;

  return (
    <div
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={cardWrapperClasses}
      data-testid="cardsStackedItemIconVariant">
      {resizedDesktopMedia && (
        <div {...liveUpdateAttrs(sys?.id, 'desktopMedia')} data-testid="desktopMedia">
          <Media
            media={resizedDesktopMedia}
            desktopAnimation={desktopAnimation}
            className="h-18 max-w-18 object-cover"
          />
        </div>
      )}
      <div className="flex flex-col gap-1">
        <div className="font-sans font-semibold" {...liveUpdateAttrs(sys?.id, 'headline')} data-testid="headline">
          <RichTextHeadline headline={headline} />
        </div>
        {shortDescription && (
          <div
            className="font-serif flex flex-col gap-6"
            {...liveUpdateAttrs(sys?.id, 'shortDescription')}
            data-testid="shortDescription">
            <RichTextList
              item={shortDescription}
              arrowStyles="text-bg-action-primary group-[.bright-green-colorway]:text-kale"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CardsStackedItemIconVariant;
